import { ReactNode, useCallback } from "react";

import BadgeNext from "ds/components/BadgeNext";
import Button from "ds/components/Button";
import { IconComponent } from "types/Icon";
import ActionCard from "ds/components/ActionCard";

import { showChangeManagementStrategyConfirmationModal } from "./ConfirmationModal";

type ManagementStrategyItemProps = {
  active: boolean;
  title: string;
  icon: IconComponent;
  children: ReactNode;
  confirmationDescription: ReactNode;
  confirmationCallback: () => void;
};

const ManagementStrategyItem = ({
  active,
  children,
  icon,
  title,
  confirmationDescription,
  confirmationCallback,
}: ManagementStrategyItemProps) => {
  const handleClick = useCallback(() => {
    if (!active) {
      showChangeManagementStrategyConfirmationModal({
        name: title,
        description: confirmationDescription,
        onConfirm: confirmationCallback,
      });
    }
  }, [active, confirmationCallback, confirmationDescription, title]);

  return (
    <ActionCard
      title={title}
      description={children}
      icon={icon}
      actionComponent={
        active ? null : (
          <Button variant="primary" onPress={handleClick}>
            Enable
          </Button>
        )
      }
      titleSuffix={active && <BadgeNext variant="green" type="strong" text="Enabled" />}
    />
  );
};

export default ManagementStrategyItem;
